import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import Lazyanime from './Components/Lazyload/lazy_anime';
import 'react-animated-slider/build/horizontal.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import './index.css';
// import Routes from './Routes';
import * as serviceWorker from './serviceWorker';
const Routes = lazy(() => import('./Routes'));

ReactDOM.render(
     <Suspense fallback={<Lazyanime />}>
<Routes />
</Suspense>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
